<template>
  <div class="page">
    <div class="logo"></div>
    <div class="box">
      <div>
        <router-link to="/">
          <div class="btn-primary card">PMS房东</div>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
window.onload = function () {
  // 调用redirectToLoginPage函数来实现跳转
  window.location.href = '/';
};
</script>

<style lang="scss" scoped>
.page {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;

  .logo {
    height: 30%;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 30px;
    font-weight: bold;
  }

  .box {
    flex: 1;
    text-align: center;
    //   height: 200px;
    //   line-height: 200px;
    font-size: 18px;
    font-weight: bold;
    color: #0094ff;
    margin: auto;
    cursor: pointer;

    .card {
      float: left;
      width: 200px;
      height: 100px;
      margin: 10px;
      border: 1px solid #f2f2f2;
      border-radius: 10px;
      padding: 5px 15px;
      display: flex;
      justify-content: center;
      flex-direction: column;
      color: #ffffff;
    }
  }
}
</style>
